import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';


@Component({
  selector: 'input-switch',
  templateUrl: './input-switch.component.html',
  styleUrls: ['./input-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSwitchComponent),
      multi: true,
    },
  ]

})
export class InputSwitchComponent extends ControlValueAccessorDirective {
  @Input() title: string = '';
  @Input() public readonly: boolean = false;
}
